export default "__VITE_ASSET__Dejoju8H__"